import { render, staticRenderFns } from "./Sponsor.vue?vue&type=template&id=f98fc3d2&scoped=true"
import script from "./Sponsor.vue?vue&type=script&lang=js"
export * from "./Sponsor.vue?vue&type=script&lang=js"
import style0 from "./Sponsor.vue?vue&type=style&index=0&id=f98fc3d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98fc3d2",
  null
  
)

export default component.exports